export default __webpack_public_path__ + "static/media/delete-modal-icon.5f75fab9.svg";